import { IMask } from "react-imask"
import { useLazyLoadQuery } from "react-relay"
import { graphql } from "relay-runtime"
import { useFormatPhoneNumberCountriesQuery } from "@/hooks/__generated__/useFormatPhoneNumberCountriesQuery.graphql"

const normalizePhoneNumber = (phoneNumber?: string | null): string => {
  if (!phoneNumber || phoneNumber === "+") return ""
  return phoneNumber.startsWith("+") ? phoneNumber : `+${phoneNumber}`
}

const countriesQuery = graphql`
  query useFormatPhoneNumberCountriesQuery {
    displayableCountries(language: "en") {
      countryLookup {
        mask
        dialCode
      }
    }
  }
`

const useFormatPhoneNumber = (phoneNumber?: string | null) => {
  const { displayableCountries } = useLazyLoadQuery<useFormatPhoneNumberCountriesQuery>(countriesQuery, {})
  const normalized = normalizePhoneNumber(phoneNumber)
  if (!normalized) return ""

  const countryMatch = displayableCountries.find(({ countryLookup: { dialCode } }) => normalized.startsWith(dialCode))
  const mask = countryMatch?.countryLookup.mask

  if (!mask || mask.replaceAll(" ", "").length !== normalized.length) return normalized

  const masked = IMask.createMask({ mask })
  masked.value = normalized
  return masked.value
}

export { useFormatPhoneNumber, countriesQuery }
